import { Component, HostBinding, Input } from "@angular/core"
import { ErrorCode } from "../error-code.model"

@Component({
    selector: "app-unauthorized-error",
    templateUrl: "./unauthorized-error.component.html",
    styleUrls: ["./unauthorized-error.component.scss"],
})
export class UnauthorizedErrorComponent {
    public image: string
    public ErrorCode = ErrorCode

    @HostBinding("style") hostBinding = "flex: 1"

    @Input()
    public nextURL: string

    @Input()
    public errorCode: ErrorCode

    @Input()
    public isStudent: boolean

    @Input()
    public errorMessage: string

    constructor() {
        this.image = require("../../../assets/Lost-in-Space.png").default
    }
}
